import { DESKTOP_MIN } from "lib/layoutConstants";
import React, { useEffect, useState } from "react";

export const CollapseStateContext = React.createContext(false);

export const CollapseProvider = ({ children }) => {
  const [viewportCollapse, setViewportCollapse] = useState(window.innerWidth <= DESKTOP_MIN);

  const onViewportCollapseBreakpoint = (e) => {
    setViewportCollapse(window.innerWidth <= DESKTOP_MIN);
  };

  useEffect(() => {
    const mq = window.matchMedia(`screen and (max-width: ${DESKTOP_MIN}px)`);
    mq.addListener(onViewportCollapseBreakpoint);
    return () => mq.removeListener(onViewportCollapseBreakpoint);
  }, []);

  return <CollapseStateContext.Provider value={viewportCollapse}>{children}</CollapseStateContext.Provider>;
};

// higher-order function to consume collapse state in a component definition
export const withCollapseState = (Component) => (props) =>
  (
    <CollapseStateContext.Consumer>
      {(collapseState) => <Component collapseState={collapseState} {...props} />}
    </CollapseStateContext.Consumer>
  );
